export const SERVICES = {
  COMMERCE: '/services/card_payment/company/commerce',

  COMPANY: '/services/card_payment/company',

  CUSTOMER: '/services/card_payment/customer/consult',

  LINKS: '/services/card_payment/transactions/link',

  PAYMENT_METHODS: '/services/card_payment/payment_methods/list',

  PEOPLE_MASSIVE: '/private/clients/massive',

  MASSIVE_METHODS: 'services/card_payment/massive/methods',

  RECURRING_CHARGERS: '/services/card_payment/tools/massives',
  RECURRING_CHARGERS_DETAILS: '/services/card_payment/tools/massives/detail',

  TAXONOMY: '/services/card_payment/taxonomy',
  TRANSACTIONS: '/services/card_payment/main/transactions',
  TRANSACTIONS_FILTERS: '/services/card_payment/txn/search_filter',

  USERS: '/services/card_payment/users_details',
  USERS_ADD: '/users/add',
  USERS_CHECK_DOCUMENT: '/users/checkKeyExist',
  USERS_GET_INFO: '/services/card_payment/users/get_info',
  USERS_OWNER: '/users/owner',
  USERS_PRESIGNIN_DOCUMENT: '/users/presignin_documents',
};

export const CONF = {};
